import React from 'react';
import { FadeIn } from './ui/FadeIn';
export function PainPointSection() {
  return <section className="py-16 md:py-24 px-4 md:px-6 bg-navy relative" data-id="element-206">
      {/* Top border gradient */}
      <div className="absolute top-0 left-0 right-0 h-1 bg-gradient-to-r from-navy via-gold to-rose" data-id="element-207" />

      <div className="max-w-4xl mx-auto" data-id="element-208">
        <FadeIn data-id="element-209">
          <div className="text-center mb-16" data-id="element-210">
            <div className="inline-block bg-navy-light border border-navy-card text-white/80 font-medium text-xs md:text-sm px-4 py-1.5 rounded-full mb-6 uppercase tracking-wider" data-id="element-211">
              Si estás leyendo esto en la madrugada...
            </div>
            <h2 className="text-3xl md:text-4xl lg:text-[2.6rem] font-serif font-bold text-white leading-tight mb-6" data-id="element-212">
              No estás fallando.
              <br data-id="element-213" />
              Estás agotada porque
              <br data-id="element-214" />
              <em className="text-rose not-italic" data-id="element-215">
                nadie te explicó el sueño de tu bebé.
              </em>
            </h2>
            <p className="text-lg md:text-xl text-white/70 leading-relaxed max-w-2xl mx-auto" data-id="element-216">
              Ya probaste de todo: cargar, mecer, pecho, chupete, ruido
              blanco... y aun así vuelves a la cama pensando:{' '}
              <strong className="text-white font-semibold" data-id="element-217">
                "¿Qué estoy haciendo mal?"
              </strong>
              <br className="hidden md:block" data-id="element-218" />
              La respuesta no es que seas mala madre. Es que te falta el mapa.
            </p>
          </div>
        </FadeIn>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-16" data-id="element-219">
          <FadeIn delay={0.1} direction="up" data-id="element-220">
            <div className="bg-navy-light rounded-2xl p-8 border border-white/5 hover:-translate-y-1 hover:shadow-lg transition-all duration-300 relative overflow-hidden group h-full" data-id="element-221">
              <div className="absolute top-0 left-0 right-0 h-[3px] bg-gradient-to-r from-navy to-navy-light scale-x-0 origin-left transition-transform duration-400 group-hover:scale-x-100" data-id="element-222" />
              <span className="text-4xl mb-4 block" data-id="element-223">😴</span>
              <h3 className="font-serif text-xl font-bold text-white mb-3" data-id="element-224">
                Se despierta cada 45 minutos
              </h3>
              <p className="text-sm text-white/70 leading-relaxed" data-id="element-225">
                No es que tu bebé "sea difícil". Es biología. Sus ciclos de
                sueño son cortos y al terminar cada uno, busca lo mismo que lo
                ayudó a dormirse.
              </p>
            </div>
          </FadeIn>

          <FadeIn delay={0.2} direction="up" data-id="element-226">
            <div className="bg-navy-light rounded-2xl p-8 border border-white/5 hover:-translate-y-1 hover:shadow-lg transition-all duration-300 relative overflow-hidden group h-full" data-id="element-227">
              <div className="absolute top-0 left-0 right-0 h-[3px] bg-gradient-to-r from-navy to-navy-light scale-x-0 origin-left transition-transform duration-400 group-hover:scale-x-100" data-id="element-228" />
              <span className="text-4xl mb-4 block" data-id="element-229">😰</span>
              <h3 className="font-serif text-xl font-bold text-white mb-3" data-id="element-230">
                La regresión de los 4 meses
              </h3>
              <p className="text-sm text-white/70 leading-relaxed" data-id="element-231">
                De un día para otro tu bebé que dormía bien ahora se despierta
                cada hora. No es retroceso, es un cambio real en sus ciclos. Y
                tiene solución.
              </p>
            </div>
          </FadeIn>

          <FadeIn delay={0.3} direction="up" data-id="element-232">
            <div className="bg-navy-light rounded-2xl p-8 border border-white/5 hover:-translate-y-1 hover:shadow-lg transition-all duration-300 relative overflow-hidden group h-full" data-id="element-233">
              <div className="absolute top-0 left-0 right-0 h-[3px] bg-gradient-to-r from-navy to-navy-light scale-x-0 origin-left transition-transform duration-400 group-hover:scale-x-100" data-id="element-234" />
              <span className="text-4xl mb-4 block" data-id="element-235">🌀</span>
              <h3 className="font-serif text-xl font-bold text-white mb-3" data-id="element-236">
                Caos total sin rutina
              </h3>
              <p className="text-sm text-white/70 leading-relaxed" data-id="element-237">
                No saber cuándo le toca dormir genera sobrecansancio. El
                cortisol se dispara y paradójicamente hace que le cueste más
                trabajo dormirse.
              </p>
            </div>
          </FadeIn>
        </div>

        <FadeIn delay={0.4} data-id="element-238">
          <div className="bg-gradient-to-br from-navy to-navy-mid rounded-3xl p-10 md:p-14 text-center text-white relative overflow-hidden border border-white/5" data-id="element-239">
            <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,rgba(255,215,0,0.1)_0%,transparent_70%)] pointer-events-none" data-id="element-240" />
            <p className="font-serif text-2xl md:text-3xl lg:text-4xl font-bold leading-tight relative z-10 mb-3" data-id="element-241">
              Esta guía no te pide que seas perfecta.
              <br data-id="element-242" />
              Te da <span className="text-gold italic" data-id="element-243">el sistema</span> que
              nadie te enseñó.
            </p>
            <p className="text-base md:text-lg text-white/70 relative z-10" data-id="element-244">
              Ciencia del sueño, aplicada con amor y respeto al apego seguro.
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}